import Divider from "@material-ui/core/Divider";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import { makeStyles } from "@material-ui/core/styles";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Outlet, Route, Routes, useNavigate } from "react-router-dom";
import { fetchDataModel } from "../../services/assortment_management/actions";
import { updateCurrentType } from "../../services/general/actions";
import TableContent from "./TableContent";
import TableEntry from "./TableEntry";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    marginTop: "20px",
  },
  text: {
    display: "flex",
    justifyContent: "center",
    marginBottom: 0,
  },
}));

function SimpleList(props) {
  const [dataModel, setDataModel] = useState();

  const classes = useStyles();
  const navigate = useNavigate();

  useEffect(() => {
    fetchDataModel().then((res) => {
      setDataModel(res);
    });
  }, []);

  function ListItemLink(props) {
    return <ListItem button component="a" {...props} />;
  }

  return (
    <>
      <Routes>
        <Route
          index
          element={
            <div className={classes.root}>
              <List component="nav" aria-label="secondary mailbox folders">
                {dataModel?.map((table) => (
                  <ListItemLink onClick={() => navigate(`${table.name}`)}>
                    <ListItemText primary={table.name} />
                    <Divider />
                  </ListItemLink>
                ))}
              </List>
            </div>
          }
        ></Route>
        <Route
          path=":table"
          element={
            <div className={classes.root}>
              <TableContent dataModel={dataModel} />
            </div>
          }
        ></Route>
        <Route
          path=":table/:entry_id"
          element={
            <div className={classes.root}>
              <TableEntry dataModel={dataModel} />
            </div>
          }
        ></Route>
        {/* <Route path="/products/:subGroupNumber/:mainGroup/:subGroup" exact>
				{props.assortmentData?.groups?.length > 0 ? (
					<ProductGrid
						assortiment={props.assortmentData?.groups}
						background={props.identifyInfo.tile_background}
					/>
				) : (
					noProducts
				)}
			</Route> */}
      </Routes>
      <Outlet />
    </>
  );
}

function mapStateToProps(state) {
  return {
    currentType: state.general.currentType,
    mainHub: state.login.login_data.mainHub,
    hub: state.login.login_data.hub,
    supplier: state.login.login_data.supplier,
  };
}

export default connect(mapStateToProps, {
  updateCurrentType,
})(SimpleList);
